import { GET_DIVISION } from 'shared/constants/ActionTypes';
import ItemCollections, { useGetItem } from 'redux/cache';
import { API } from 'shared/constants/AppEnums';
const itemCollections = new ItemCollections();
export const getDivisions = (useCRSFE=false) => {
  let keyUrl;
  if (useCRSFE){
    keyUrl = API.GET_DIVISIONS_ADMINTOOLS;
  }else{
    keyUrl = API.TITLE_TREE;
  }
  return useGetItem(itemCollections, keyUrl, GET_DIVISION, true,true,false,useCRSFE);
};
